import { Component, Output, EventEmitter, OnInit, AfterViewInit, OnDestroy, Inject  } from '@angular/core';
import { ArticleService } from '../article.service';
import { APP_CONFIG, AppConfig } from '../../config/app.config.module';
import { NavService } from '../../header/nav/nav.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BreadcrumbService } from '../../header/breadcrumb/breadcrumb.service';
import { ValidateService } from '../../common/validate.service';
import { SharedService} from '../../common/shared.service';
import 'rxjs/add/operator/switchMap';
import { ISubscription } from 'rxjs/Subscription';
import { TopnavService } from '../../header/topnav/topnav.service';
import { HttpClient } from '@angular/common/http';
import { PortalService } from '../../services/portal.service';
import { ToastrService } from 'ngx-toastr';
import { SafeHtmlPipe } from '../../pipe/safe-html.pipe';
import { Title } from '@angular/platform-browser';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: May 5th 2018
 * 
 * Description: Component class for Content - content/:id1
 **/
@Component({
  selector: 'gosg-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css'],
  providers: [ SafeHtmlPipe ]
})
export class ContentComponent implements OnInit, AfterViewInit, OnDestroy {
  statusID: any;
  @Output() menuClick = new EventEmitter();
  breadcrumb: any;
  isValid: any;
  topicID: number;
  subID: number;
  moduleName: string;
  articles: any[];
  public scoreFormgrp: FormGroup;
  score: FormControl;
  remarks: FormControl;
  public strNotFound: string = '';

  articleData: any;
  @Output() langChange = new EventEmitter();
  loading: boolean;
  lang;
  langId;

  handleClickMe(e){

  }

  private subscriptionLang: ISubscription;
  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  public myflag: any;
  private contentLoaded: boolean = false;

  constructor(
    private title: Title,
    public safeHtml : SafeHtmlPipe,
    private http:HttpClient,
    public articleService: ArticleService,
    private topnavservice: TopnavService,
    private route: ActivatedRoute,
    private navService: NavService,
    private translate: TranslateService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    @Inject(APP_CONFIG) private config: AppConfig,
    private validateService:ValidateService,
    private sharedService :SharedService,
    private portalService:PortalService,
    private toastr: ToastrService) {
       if (this.router.url.split('/')[1]!=='content') {
         console.log('Successfully reject initialize if request comes from different component');
         return;
       }

        this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {
        console.log('content-onLangChange');
        
        this.strNotFound = '';
        const myLang = translate.currentLang;

        if (myLang == 'en') {

            translate.get('HOME').subscribe((res: any) => {
                this.lang = 'en';
                this.langId = 1;
                this.moduleName = this.router.url.split('/')[1];
                this.topicID = parseInt(this.router.url.split('/')[2]);
                var tt = this.router.url.split('/');
                this.subID = parseInt(tt[tt.length-1]);
            });
        }
        if (myLang == 'ms') {

            translate.get('HOME').subscribe((res: any) => {
                this.lang = 'ms';
                this.langId = 2;
                this.moduleName = this.router.url.split('/')[1];
                this.topicID = parseInt(this.router.url.split('/')[2]);
                var tt = this.router.url.split('/');
                this.subID = parseInt(tt[tt.length-1]);
            });

        }

        if(this.moduleName == 'subcategory' || this.moduleName == 'category') {
          console.log('return if not a content request');
          return;
        } else if (!this.contentLoaded) {
          console.log('return if content not yet loaded.');
          return;
        }

        if(this.topnavservice.flagLang){

          if(this.moduleName == 'content') {
            this.navService.triggerContent(this.subID, this.langId, 'stopaudit');
            /*setTimeout(()=>{
              if (this.langId === 1) {
                this.strNotFound = '<span class="font-size-l" style="text-align: center;">Content Not Found</span>';
              } else {
                this.strNotFound = '<span class="font-size-l" style="text-align: center;">Kandungan Tidak Dijumpai</span>';
              }
            }, 1000);*/
          }

          /*if(this.moduleName == 'subcategory'){
            this.navService.triggerSubArticle(this.subID, this.langId, 'stopaudit');
          }else if(this.moduleName == 'content'){
            this.navService.triggerContent(this.subID, this.langId, 'stopaudit');
          }else{
            this.navService.triggerArticle(this.moduleName,  this.langId, this.topicID, 'stopaudit');
          }*/
      
        }

    });

    route.params.subscribe(val => {
      if (this.moduleName == 'content') {
        this.ngOnInit();
      }
    });

    this.route.queryParams.subscribe(params => {
      let lng = params['language'];
      if (lng && lng.toLowerCase() == 'my') {
        this.myflag = {language:"my"};
        this.translate.setDefaultLang('ms');
        this.translate.use('ms');
      } else {
        this.myflag = null;
      } 
    });


    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
      $('.font-size-l').css('font-size', this.fontSize.sizeL);
      $('.font-size-m').css('font-size', this.fontSize.sizeM);
      $('.font-size-s').css('font-size', this.fontSize.sizeS);
    });

   }

   boolCallback = (result: boolean) : void => {
    this.loading = result;
   }

  ngOnInit() {

    if(!this.langId){
      if (localStorage.getItem('langID')) {
        this.langId = localStorage.getItem('langID');
      } else {
        this.langId = 1;
      }
    }

    this.articleData = this.articleService.getArticle();
    this.topicID = parseInt(this.router.url.split('/')[2]);
    this.moduleName = this.router.url.split('/')[1];
    var tt = this.router.url.split('/');
    this.subID = parseInt(tt[tt.length-1]);

    this.loading = true;

    setTimeout(()=>{
      this.navService.triggerContent(this.subID, localStorage.getItem('langID'),'initcontent');
      this.contentLoaded = true;
    }, 400);
    

    this.score = new FormControl('', [Validators.required]);
    this.remarks = new FormControl('');
    this.scoreFormgrp = new FormGroup({
      score: this.score,
      remarks: this.remarks

    });

  }

  ngAfterViewInit() {
    setTimeout(() => {
        this.sharedService.sentToGtag();
    }, 500);  
    
    this.sharedService.loadFontSizeData();
  }

  ngOnDestroy() {
    console.log('content-destroy');
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
  }

  getTheme(){
    return localStorage.getItem('themeColor');
  }

  appTracking(refCode){
    const readUrl = `${this.config.urlPortal}agencyapplication/tracking?refCode=${refCode}&source=life-event`;
    const req = this.http.post(readUrl,'')
      .subscribe(
        res => {

        },
        err => {
          console.log("Error occured");
        }
      );
  }

  getRate(val){

  }

  submitForm(formValues:any){
    let body = {
        "contentCode": null,
        "score": null,
        "remarks": null
    };

    body.contentCode = this.subID;
    body.score = parseInt(formValues.score);
    body.remarks = formValues.remarks;

    // let datasend = JSON.stringify(body);

      this.portalService.submitScore(body).subscribe(
        data => {

          this.sharedService.errorHandling(data, (function(){
            this.getRateReset();
            this.sharedService.showSuccess(this.translate.instant('rating.msgsubmit'), '');
        }).bind(this));
      },
      error => {
        //this.sharedService.showError((error._body.statusDesc), '');

      });

  }

  getRateReset(){
    this.scoreFormgrp.reset();
  }

  clickSideMenu(e, status, event){
    this.navService.loader = true;
    this.statusID = status;
    // this.navService.getSubArticleUrl( e.categoryId, localStorage.getItem('langID'));
    // this.navService.triggerSubArticle(e.categoryCode, localStorage.getItem('langID'));
    this.router.navigate( ['/subcategory', e.categoryCode], { queryParams: this.myflag });
    event.preventDefault();
  }

  clickSideMenuByAgency(e, status, event){
    this.navService.loader = true;
    this.navService.getSubArticleUrlByAgency(localStorage.getItem('langID'));
    this.navService.triggerSubArticleAgency(localStorage.getItem('langID'));
    this.router.navigate(['/subcategory', 'agency'], { queryParams: this.myflag });
    event.preventDefault();
  }

  clickContentFromMenu(pId, aId, status, event){
    this.navService.loader = true;
    this.statusID = status;
    this.navService.triggerContent(aId, localStorage.getItem('langID'));
    this.navService.getContentUrl(aId, localStorage.getItem('langID'));
    this.router.navigate( ['/content', aId], { queryParams: this.myflag });
    event.preventDefault();
  }

  getModule(data){
    let a = data.split("/");
    return a[1];
  }

  getID(data){
    let a = data.split("/");
    return a[2];
  }

  checkImgData(e){
      const chkData = e.search('<img');
      if (chkData != -1){
          return true;
      }else{
          return false;
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/article/content/content.component.ts